import React from 'react';

const MobileMenu = () => {

  return (
    <>
        {/* Mobile Menu */}
        <div className="mobile-menu">
            <div className="menu-backdrop"></div>
            <div className="close-btn"><i className="fas fa-times"></i></div>
            
            <nav className="menu-box">
                <div className="nav-logo" style={{display: 'none'}}><a href="/"><img src="assets/images/logo_new.jpeg" alt="" title="" /></a></div>
                <div className="menu-outer">{/*Here Menu Will Come Automatically Via Javascript / Same Menu as in Header*/}</div>
                <div className="contact-info">
                    <h4>Contact Info</h4>
                    <ul>
                        <li><a href="https://maps.app.goo.gl/Coc7TBGjEj715mDs6" target="_blank" rel="noopener noreferrer">D.No.87-1165, Hosanna Mandir Road, Nandyal Road, Revenue Colony, Kurnool, Andhra Pradesh 518002, India</a></li>
                        <li><a href="tel:9963276070">9963276070</a></li>
                        <li><a href="mailto:reddyg.spurthi@gmail.com">reddyg.spurthi@gmail.com</a></li>
                    </ul>
                </div>
                <div className="social-links">
                    <ul className="clearfix">
                        <li style={{display: 'none'}}><a href="/"><span className="fab fa-twitter"></span></a></li>
                        <li><a href="https://www.facebook.com/profile.php?id=100091975440305&mibextid=ZbWKwL"><span className="fab fa-facebook-square"></span></a></li>
                        <li style={{display: 'none'}}><a href="/"><span className="fab fa-pinterest-p"></span></a></li>
                        <li><a href="https://instagram.com/sunshineadvancedeyecare?igshid=MzRlODBiNWFlZA=="><span className="fab fa-instagram"></span></a></li>
                        <li style={{display: 'none'}}><a href="/"><span className="fab fa-youtube"></span></a></li>
                    </ul>
                </div>
            </nav>
        </div>
        {/* End Mobile Menu */}
    </>
    );
  }
  
  export default MobileMenu;